<template>
  <header ref="formRef">
    <div id="pc-header" v-show="!mobile">
      <div class="map">
      <div class="main-center">
        <a href="javascript:void(0)" @click="redrect2Url('about')">About</a>
        <a href="javascript:void(0)" @click="redrect2Url('transfer')">Credit Transfer</a>
        <a href="javascript:void(0)" @click="redrect2Url('document')">How LightCourse Works</a>
        <a href="javascript:void(0)" @click="redrect2Url('toapply')">How to Apply</a>
        <a href="javascript:void(0)" @click="redrect2Url('contact')" style="margin-right:0.5rem;">Contact Us</a>
      </div>
    </div>
      <div class="main-center">
      <a href="/" class="logo"><img :src='this.$store.state.baseURL+ "/new/images/logonew.png"' alt="LightCourse" /></a>
      <div class="search-form">
        <div class="h-btn">
          <span>Courses</span>
          <svg class="iconf" aria-hidden="true" style="color: #fff;">
            <use xlink:href="#icon-down"></use>
          </svg>
          <div class="content">
            <nav>
              <ul class="courses-ul">
                <h3>COURSES</h3>
                <template v-for="(cate, index) in cateList">
                <li v-if="cate.hotCourseItemList && cate.hotCourseItemList.length > 0" @click="switchCourse(index)">
                  <div><span>{{cate.name}}</span><i class="iconfont icon-right"></i></div>
                </li>
                </template>
                <div class="more-btn">
                  <a href="javascript:void(0)" @click="redrect2Url('course')" class="more">View All Disciplines</a>
                </div>
              </ul>
              <ul class="program-ul">
                <h3>PROGRAMS</h3>
                <template v-for="(program, index) in programs">
                <li @click="switchProgram(index)">
                  <div><span>{{program.locate}}</span><i class="iconfont icon-right"></i>
                  </div>
                </li>
                </template>
                <div class="more-btn">
                  <a href="javascript:void(0)" @click="redrect2Url('program')" class="more">View All Programs</a>
                </div>
              </ul>
            </nav>
            <aside>
              <div v-show="panel=='course'" class="courses-wrap active">
                <div class="item active">
                  <div class="tit">
                    <h4>{{selectCate.name}}<svg class="iconf" aria-hidden="true">
                      <use xlink:href="#icon-hot"></use>
                    </svg></h4>
                    <!--  <p>{$item.gc_name} courses</p>-->
<!--                    <div class="close"><svg class="iconf" aria-hidden="true">-->
<!--                      <use xlink:href="#icon-close"></use>-->
<!--                    </svg></div>-->
                  </div>
                  <ol>
                    <template v-for="(item, index) in selectCate.hotCourseItemList">
                    <li>
                      <a  href="javascript:void(0);" @click="resirect2Detail(item)">
                        <h5>{{item.courseName}}<em v-for="mode in modes" v-if="item.courseMode == mode.value">{{ mode.text }}</em></h5>
                        <p>
                          <span>{{ item.uniCourseCode }}</span>
                          <span>{{ item.uniName }}</span>
                        </p>
                      </a>
                    </li>
                    </template>
                  </ol>
                  <div class="more-btn">
                    <a href="javascript:void(0)" @click="redrect2Url('course')" class="more">Learn More</a>
                  </div>
                </div>
              </div>
              <div v-show="panel=='program'" class="program-wrap active">
                <div class="item active">
                  <div class="tit">
                    <h4>PROGRAMS</h4>
                    <!-- <p>Hot program</p>-->
<!--                    <div class="close"><i class="iconfont icon-close"></i></div>-->
                  </div>
                  <ol>
                    <li>
                      <div class="p-tit">
                        <div>
                          <h6>{{selectProgram.name}}</h6>
                          <p><i class="iconfont">{{selectProgram.locate}}</i></p>
                        </div>
                        <div class="t-logo"><img
                            :src="selectProgram.backImage" alt=""></div>
                      </div>
                      <div class="field">
                        <div class="list">
                          <svg class="iconf" aria-hidden="true">
                            <use xlink:href="#icon-yuanxiao"></use>
                          </svg>
                          <label for="">· Institution</label>
                          <span>{{selectProgram.college}}</span>
                        </div>
                        <div class="list">
                          <svg class="iconf" aria-hidden="true">
                            <use xlink:href="#icon-shijian"></use>
                          </svg>
                          <label for="">· Date</label>
                          <span>{{selectProgram.period}}</span>
                        </div>
                        <div class="list">
                          <svg class="iconf" aria-hidden="true">
                            <use xlink:href="#icon-rili"></use>
                          </svg>
                          <label for="">· Duration</label>
                          <span>{{selectProgram.duration}}</span>
                        </div>
                        <div class="list">
                          <svg class="iconf" aria-hidden="true">
                            <use xlink:href="#icon-renqun"></use>
                          </svg>
                          <label for="">· Audience</label>
                          <span>{{selectProgram.people}}</span>
                        </div>
                      </div>
                    </li>
                  </ol>
                  <div class="more-btn">
                    <a href="javascript:void(0)" @click="redrect2Item(selectProgram.index)" class="more">Learn More</a>
                  </div>
                </div>
              </div>
            </aside>
          </div>
        </div>
        <div class="search-inp">
          <input type="text" class="homeinputval" v-model="search" @input="searchCourse" name="keyword" autocomplete="off" placeholder="Find a Course">
          <button type="button" @click="redrect2Course" class="i homesearch"><svg class="iconf" aria-hidden="true"
                                                          style="color: #fff;">
            <use xlink:href="#icon-search"></use>
          </svg></button>

          <div class="hint-search-content" style="display: block" v-if="search != null && search != '' && showResult">
            <div class="item course-item">
              <h4>Course</h4>
              <div class="i-list" v-if="courseList && courseList.length > 0">
                <template v-for="(item, index) in courseList">
                  <a href="javascript:void(0);" @click="resirect2Detail(item)" class="link">
                    <span>{{item.courseName}}</span>
                    <em>{{item.uniName}}</em>
                  </a>
                </template>
              </div>
              <div class="i-list" v-else>
                <a href="javascript:void(0);" class="link">
                  <span>No Results...</span>
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
      <ul>
<!--        {foreach name="top_menu" item="val"}-->
        <li :class="homeActive">
          <a href="javascript:void(0)" @click="redrect2Url('home')">HOME</a>
        </li>
        <li :class="courseActive">
          <a href="javascript:void(0)" @click="redrect2Url('course')">COURSES</a>
        </li>
        <li :class="programActive">
          <a href="javascript:void(0)" @click="redrect2Url('program')">PROGRAMS</a>
        </li>
<!--        {/foreach}-->
      </ul>
      <div class="right">
        <div class="member">
          <!-- <div class="i"><img src="" alt=""></div> -->
          <p>
            <a href="javascript:void(0)" @click="redrect2Url('reg')">Register</a>
            <a href="javascript:void(0)" @click="redrect2Url('login')">Login</a>
          </p>
        </div>
        <div class="h-btn">
          <a href="javascript:;" @click="openQrCodeBuy" class="i">
            <svg class="iconf" aria-hidden="true" style="color: #fff;">
            <use xlink:href="#icon-gouwuche1"></use>
<!--            <div class="addcart-goods-num">{$cart_goods_num}</div>-->
            </svg>
          </a>
          <!-- <a href="javascript:;" class="i"><span>EN</span></a> -->
        </div>
      </div>
    </div>
    </div>
    <div id="mb-header" v-show="mobile">
      <div class="navbar main" id="navbar-main">
      <div id="search-ico" @click="showMobileInput=!showMobileInput">
        <svg class="iconf" aria-hidden="true">
          <use xlink:href="#icon-search"></use>
        </svg>
      </div>
      <div id="logo" style="width: 250px; padding-left: 10px; padding-right: 10px; text-align: center;">
        <a href="/" v-if="!showMobileInput">
          <img style="width: 35%;" :src='this.$store.state.baseURL + "/new/images/logonew.png"' alt="LightCourse" />
        </a>
        <input v-if="showMobileInput" type="text" class="moble-search" v-model="search" @input="searchCourse" name="keyword" autocomplete="off" placeholder="Find a Course">
        <div class="hint-search-content" style="display: block" v-if="search != null && search != '' && showResult">
          <div class="item course-item">
            <h4>Course</h4>
            <div class="i-list" v-if="courseList && courseList.length > 0">
              <template v-for="(item, index) in courseList">
                <a href="javascript:void(0);" @click="resirect2Detail(item)" class="link">
                  <span>{{item.courseName}}</span>
                  <em>{{item.uniName}}</em>
                </a>
              </template>
            </div>
            <div class="i-list" v-else>
              <a href="javascript:void(0);" class="link">
                <span>No Results...</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div id="sidebar-main-trigger" @click="showMenu"></div>
    </div>
      <div class="sidebar" v-show="showMoblileMenu" id="sidebar-main" style="position: fixed; right: 0; top:52px">
      <div class="wrapper">
        <div class="member">
          <a href="javascript:void(0)" @click="redrect2Url('login')" class="c1">Sign in</a>
          <a href="javascript:void(0)" @click="redrect2Url('reg')" class="c2">Register</a>
        </div>
        <nav>
          <ul id="accordion" class="accordion main-center">
            <li>
              <a href="javascript:void(0)" @click="redrect2Url('home')" class="link">
                <div>HOME</div>
                <div><svg t="1646820115210" class="iconf" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="1843" width="200" height="200">
                  <path
                      d="M644.896 514.656c-4.647-3.465-7.707-5.211-10.102-7.614-111.882-111.777-223.68-223.642-335.584-335.395-11.498-11.482-17.601-24.432-14.060-40.893 6.549-30.444 42.724-43.056 66.702-23.206 2.638 2.179 5.006 4.691 7.43 7.116 122.147 122.131 244.29 244.268 366.434 366.411 22.218 22.218 22.236 44.944 0.033 67.143-122.749 122.755-245.548 245.451-368.185 368.316-12.166 12.191-26.062 17.589-42.734 13.327-28.957-7.395-40.247-42.511-21.462-65.828 2.323-2.881 5.046-5.457 7.668-8.083 111.214-111.228 222.435-222.459 333.706-333.634 2.407-2.404 5.469-4.166 10.148-7.66z"
                      p-id="1844"></path>
                </svg></div>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)" @click="redrect2Url('course')" class="link">
                <div>Courses</div>
                <div><svg t="1646820115210" class="iconf" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="1843" width="200" height="200">
                  <path
                      d="M644.896 514.656c-4.647-3.465-7.707-5.211-10.102-7.614-111.882-111.777-223.68-223.642-335.584-335.395-11.498-11.482-17.601-24.432-14.060-40.893 6.549-30.444 42.724-43.056 66.702-23.206 2.638 2.179 5.006 4.691 7.43 7.116 122.147 122.131 244.29 244.268 366.434 366.411 22.218 22.218 22.236 44.944 0.033 67.143-122.749 122.755-245.548 245.451-368.185 368.316-12.166 12.191-26.062 17.589-42.734 13.327-28.957-7.395-40.247-42.511-21.462-65.828 2.323-2.881 5.046-5.457 7.668-8.083 111.214-111.228 222.435-222.459 333.706-333.634 2.407-2.404 5.469-4.166 10.148-7.66z"
                      p-id="1844"></path>
                </svg></div>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)" @click="redrect2Url('program')" class="link">
                <div>Programs</div>
                <div><svg t="1646820115210" class="iconf" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="1843" width="200" height="200">
                  <path
                      d="M644.896 514.656c-4.647-3.465-7.707-5.211-10.102-7.614-111.882-111.777-223.68-223.642-335.584-335.395-11.498-11.482-17.601-24.432-14.060-40.893 6.549-30.444 42.724-43.056 66.702-23.206 2.638 2.179 5.006 4.691 7.43 7.116 122.147 122.131 244.29 244.268 366.434 366.411 22.218 22.218 22.236 44.944 0.033 67.143-122.749 122.755-245.548 245.451-368.185 368.316-12.166 12.191-26.062 17.589-42.734 13.327-28.957-7.395-40.247-42.511-21.462-65.828 2.323-2.881 5.046-5.457 7.668-8.083 111.214-111.228 222.435-222.459 333.706-333.634 2.407-2.404 5.469-4.166 10.148-7.66z"
                      p-id="1844"></path>
                </svg></div>
              </a>
            </li>

            <li>
              <a href="javascript:void(0)" @click="redrect2Url('document')" class="link">
                <div>How LightCourse Works</div>
                <div><svg t="1646820115210" class="iconf" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="1843" width="200" height="200">
                  <path
                      d="M644.896 514.656c-4.647-3.465-7.707-5.211-10.102-7.614-111.882-111.777-223.68-223.642-335.584-335.395-11.498-11.482-17.601-24.432-14.060-40.893 6.549-30.444 42.724-43.056 66.702-23.206 2.638 2.179 5.006 4.691 7.43 7.116 122.147 122.131 244.29 244.268 366.434 366.411 22.218 22.218 22.236 44.944 0.033 67.143-122.749 122.755-245.548 245.451-368.185 368.316-12.166 12.191-26.062 17.589-42.734 13.327-28.957-7.395-40.247-42.511-21.462-65.828 2.323-2.881 5.046-5.457 7.668-8.083 111.214-111.228 222.435-222.459 333.706-333.634 2.407-2.404 5.469-4.166 10.148-7.66z"
                      p-id="1844"></path>
                </svg></div>
              </a>
            </li>
            <li>
              <a  href="javascript:void(0)" @click="redrect2Url('transfer')" class="link">
                <div>Credit Transfer</div>
                <div><svg t="1646820115210" class="iconf" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="1843" width="200" height="200">
                  <path
                      d="M644.896 514.656c-4.647-3.465-7.707-5.211-10.102-7.614-111.882-111.777-223.68-223.642-335.584-335.395-11.498-11.482-17.601-24.432-14.060-40.893 6.549-30.444 42.724-43.056 66.702-23.206 2.638 2.179 5.006 4.691 7.43 7.116 122.147 122.131 244.29 244.268 366.434 366.411 22.218 22.218 22.236 44.944 0.033 67.143-122.749 122.755-245.548 245.451-368.185 368.316-12.166 12.191-26.062 17.589-42.734 13.327-28.957-7.395-40.247-42.511-21.462-65.828 2.323-2.881 5.046-5.457 7.668-8.083 111.214-111.228 222.435-222.459 333.706-333.634 2.407-2.404 5.469-4.166 10.148-7.66z"
                      p-id="1844"></path>
                </svg></div>
              </a>
            </li>
<!--            <li>-->
<!--              <a href="javascript:void(0)" @click="redrect2Url('activity')" class="link">-->
<!--                <p>Students Story</p>-->
<!--                <div><svg t="1646820115210" class="iconf" viewBox="0 0 1024 1024" version="1.1"-->
<!--                          xmlns="http://www.w3.org/2000/svg" p-id="1843" width="200" height="200">-->
<!--                  <path-->
<!--                      d="M644.896 514.656c-4.647-3.465-7.707-5.211-10.102-7.614-111.882-111.777-223.68-223.642-335.584-335.395-11.498-11.482-17.601-24.432-14.060-40.893 6.549-30.444 42.724-43.056 66.702-23.206 2.638 2.179 5.006 4.691 7.43 7.116 122.147 122.131 244.29 244.268 366.434 366.411 22.218 22.218 22.236 44.944 0.033 67.143-122.749 122.755-245.548 245.451-368.185 368.316-12.166 12.191-26.062 17.589-42.734 13.327-28.957-7.395-40.247-42.511-21.462-65.828 2.323-2.881 5.046-5.457 7.668-8.083 111.214-111.228 222.435-222.459 333.706-333.634 2.407-2.404 5.469-4.166 10.148-7.66z"-->
<!--                      p-id="1844"></path>-->
<!--                </svg></div>-->
<!--              </a>-->
<!--            </li>-->
            <li>
              <a href="javascript:void(0)" @click="redrect2Url('toapply')" class="link">
                <div>How To Apply</div>
                <div><svg t="1646820115210" class="iconf" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="1843" width="200" height="200">
                  <path
                      d="M644.896 514.656c-4.647-3.465-7.707-5.211-10.102-7.614-111.882-111.777-223.68-223.642-335.584-335.395-11.498-11.482-17.601-24.432-14.060-40.893 6.549-30.444 42.724-43.056 66.702-23.206 2.638 2.179 5.006 4.691 7.43 7.116 122.147 122.131 244.29 244.268 366.434 366.411 22.218 22.218 22.236 44.944 0.033 67.143-122.749 122.755-245.548 245.451-368.185 368.316-12.166 12.191-26.062 17.589-42.734 13.327-28.957-7.395-40.247-42.511-21.462-65.828 2.323-2.881 5.046-5.457 7.668-8.083 111.214-111.228 222.435-222.459 333.706-333.634 2.407-2.404 5.469-4.166 10.148-7.66z"
                      p-id="1844"></path>
                </svg></div>
              </a>
            </li>
            <li>
              <a href="javascript:void(0)" @click="redrect2Url('faq')" class="link">
                <div>FAQ</div>
                <div><svg t="1646820115210" class="iconf" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="1843" width="200" height="200">
                  <path
                      d="M644.896 514.656c-4.647-3.465-7.707-5.211-10.102-7.614-111.882-111.777-223.68-223.642-335.584-335.395-11.498-11.482-17.601-24.432-14.060-40.893 6.549-30.444 42.724-43.056 66.702-23.206 2.638 2.179 5.006 4.691 7.43 7.116 122.147 122.131 244.29 244.268 366.434 366.411 22.218 22.218 22.236 44.944 0.033 67.143-122.749 122.755-245.548 245.451-368.185 368.316-12.166 12.191-26.062 17.589-42.734 13.327-28.957-7.395-40.247-42.511-21.462-65.828 2.323-2.881 5.046-5.457 7.668-8.083 111.214-111.228 222.435-222.459 333.706-333.634 2.407-2.404 5.469-4.166 10.148-7.66z"
                      p-id="1844"></path>
                </svg></div>
              </a>
            </li>

            <li>
              <a  href="javascript:void(0)" @click="redrect2Url('about')" class="link">
                <div>About Us</div>
                <div><svg t="1646820115210" class="iconf" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="1843" width="200" height="200">
                  <path
                      d="M644.896 514.656c-4.647-3.465-7.707-5.211-10.102-7.614-111.882-111.777-223.68-223.642-335.584-335.395-11.498-11.482-17.601-24.432-14.060-40.893 6.549-30.444 42.724-43.056 66.702-23.206 2.638 2.179 5.006 4.691 7.43 7.116 122.147 122.131 244.29 244.268 366.434 366.411 22.218 22.218 22.236 44.944 0.033 67.143-122.749 122.755-245.548 245.451-368.185 368.316-12.166 12.191-26.062 17.589-42.734 13.327-28.957-7.395-40.247-42.511-21.462-65.828 2.323-2.881 5.046-5.457 7.668-8.083 111.214-111.228 222.435-222.459 333.706-333.634 2.407-2.404 5.469-4.166 10.148-7.66z"
                      p-id="1844"></path>
                </svg></div>
              </a>
            </li>
<!--            <li>-->
<!--              <a href="javascript:void(0)" @click="redrect2Url('activity')" class="link">-->
<!--                <p>Join Us</p>-->
<!--                <div><svg t="1646820115210" class="iconf" viewBox="0 0 1024 1024" version="1.1"-->
<!--                          xmlns="http://www.w3.org/2000/svg" p-id="1843" width="200" height="200">-->
<!--                  <path-->
<!--                      d="M644.896 514.656c-4.647-3.465-7.707-5.211-10.102-7.614-111.882-111.777-223.68-223.642-335.584-335.395-11.498-11.482-17.601-24.432-14.060-40.893 6.549-30.444 42.724-43.056 66.702-23.206 2.638 2.179 5.006 4.691 7.43 7.116 122.147 122.131 244.29 244.268 366.434 366.411 22.218 22.218 22.236 44.944 0.033 67.143-122.749 122.755-245.548 245.451-368.185 368.316-12.166 12.191-26.062 17.589-42.734 13.327-28.957-7.395-40.247-42.511-21.462-65.828 2.323-2.881 5.046-5.457 7.668-8.083 111.214-111.228 222.435-222.459 333.706-333.634 2.407-2.404 5.469-4.166 10.148-7.66z"-->
<!--                      p-id="1844"></path>-->
<!--                </svg></div>-->
<!--              </a>-->
<!--            </li>-->
            <li>
              <a href="javascript:void(0)" @click="redrect2Url('activity')" class="link">
                <div>Collaborate With Us</div>
                <div><svg t="1646820115210" class="iconf" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="1843" width="200" height="200">
                  <path
                      d="M644.896 514.656c-4.647-3.465-7.707-5.211-10.102-7.614-111.882-111.777-223.68-223.642-335.584-335.395-11.498-11.482-17.601-24.432-14.060-40.893 6.549-30.444 42.724-43.056 66.702-23.206 2.638 2.179 5.006 4.691 7.43 7.116 122.147 122.131 244.29 244.268 366.434 366.411 22.218 22.218 22.236 44.944 0.033 67.143-122.749 122.755-245.548 245.451-368.185 368.316-12.166 12.191-26.062 17.589-42.734 13.327-28.957-7.395-40.247-42.511-21.462-65.828 2.323-2.881 5.046-5.457 7.668-8.083 111.214-111.228 222.435-222.459 333.706-333.634 2.407-2.404 5.469-4.166 10.148-7.66z"
                      p-id="1844"></path>
                </svg></div>
              </a>
            </li>
            <li>
              <a  href="javascript:void(0)" @click="redrect2Url('blog')" class="link">
                <div>Blog</div>
                <div><svg t="1646820115210" class="iconf" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="1843" width="200" height="200">
                  <path
                      d="M644.896 514.656c-4.647-3.465-7.707-5.211-10.102-7.614-111.882-111.777-223.68-223.642-335.584-335.395-11.498-11.482-17.601-24.432-14.060-40.893 6.549-30.444 42.724-43.056 66.702-23.206 2.638 2.179 5.006 4.691 7.43 7.116 122.147 122.131 244.29 244.268 366.434 366.411 22.218 22.218 22.236 44.944 0.033 67.143-122.749 122.755-245.548 245.451-368.185 368.316-12.166 12.191-26.062 17.589-42.734 13.327-28.957-7.395-40.247-42.511-21.462-65.828 2.323-2.881 5.046-5.457 7.668-8.083 111.214-111.228 222.435-222.459 333.706-333.634 2.407-2.404 5.469-4.166 10.148-7.66z"
                      p-id="1844"></path>
                </svg></div>
              </a>
            </li>
            <li>
              <a  href="javascript:void(0)" @click="redrect2Url('contact')" class="link">
                <div>Contact Us</div>
                <div><svg t="1646820115210" class="iconf" viewBox="0 0 1024 1024" version="1.1"
                          xmlns="http://www.w3.org/2000/svg" p-id="1843" width="200" height="200">
                  <path
                      d="M644.896 514.656c-4.647-3.465-7.707-5.211-10.102-7.614-111.882-111.777-223.68-223.642-335.584-335.395-11.498-11.482-17.601-24.432-14.060-40.893 6.549-30.444 42.724-43.056 66.702-23.206 2.638 2.179 5.006 4.691 7.43 7.116 122.147 122.131 244.29 244.268 366.434 366.411 22.218 22.218 22.236 44.944 0.033 67.143-122.749 122.755-245.548 245.451-368.185 368.316-12.166 12.191-26.062 17.589-42.734 13.327-28.957-7.395-40.247-42.511-21.462-65.828 2.323-2.881 5.046-5.457 7.668-8.083 111.214-111.228 222.435-222.459 333.706-333.634 2.407-2.404 5.469-4.166 10.148-7.66z"
                      p-id="1844"></path>
                </svg></div>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    </div>
    <QrCodeBuy ref="qrCodeBuy"></QrCodeBuy>
  </header>
</template>

<script>
import {getCategory, getCategoryCourse, getCourseList} from "../../api/course";
import QrCodeBuy from "../Contact/QrCodeBuy";
export default {
  components: {QrCodeBuy},
    data(){
      return{
        showMobileInput: false,
        showMoblileMenu: false,
        mobile: false,
        homeActive: "",
        courseActive: "",
        programActive: "",
        cateList:[],
        selectCate: {
          hotCourseItemList:[]
        },
        modes: [
          { value: '1', text: 'Live', checked: false },
          { value: '2', text: 'Recorded', checked: false },
          { value: '3', text: 'On Campus', checked: false },
        ],
        programs: [{
          backImage: this.$store.state.uploadURL + "/home/common/63ab9dfe15a46.jpg",
          uniName: "Sichuan University",
          name: "Sichuan University International Summer Credit Course Program",
          locate: "Chengdu, China",
          college: "Sichuan University",
          period: "6/27/2024-7/29/2024",
          duration: "5 weeks",
          people: "To all eligible students",
        }, {
          backImage: this.$store.state.uploadURL + "/home/common/63aba581cbd60.png",
          uniName: "University of California, Berkeley",
          name: "Berkeley Summer Session",
          locate: "Berkeley, US",
          college: "University of California, Berkeley",
          period: "5/22/2024-8/11/2024",
          duration: "3~12 weeks",
          people: "To all eligible students"
        }],
        selectProgram: {},
        panel: "course",
        search: null,
        showResult: false,
        courseList: []
      }
    },
    created() {
      this.queryCates();
    },
    mounted() {
      // var currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      // if (currentScroll > 0) {
      //   window.scrollTo(0, currentScroll - currentScroll / 6);
      // }
      let that = this;
      this.$nextTick(()=> {
        if(that.$refs.formRef.offsetWidth < 900){
          this.mobile = false;
          this.$store.state.mobile = false;
        }else{
          this.mobile = true;
          this.$store.state.mobile = true;
        }
      });
      let _self = this;
      document.addEventListener('click', (e) => {
        _self.showResult = false;
      })
    },
    computed: {

    },
    watch: {
      '$route'(to, from) {
        let path = to.path;
        this.homeActive = "";
        this.courseActive = "";
        this.programActive = "";
        if (path == "/home") {
          this.homeActive = "active";
        } else if (path == "/course") {
          this.courseActive = "active";
        } else if (path == "/program") {
          this.programActive = "active";
        }
        if (this.$route && this.$route.meta) {
          const pdom = document.querySelector(".body-normal")
          if (this.$route.meta.showHeaderTop) {
            pdom.classList.remove('hideHeader');
          } else {
            pdom.classList.add('hideHeader');
          }
        }
      }
    },
    methods:{
      showMenu() {
        this.showMoblileMenu = !this.showMoblileMenu;
      },
      async queryCates () {
        const resp = await getCategoryCourse();
        this.cateList = resp.data;
        if (this.cateList) {
          this.selectCate = this.cateList[0];
        }
      },
      openQrCodeBuy() {
        this.$refs.qrCodeBuy.showChatQr();
      },
      resirect2Detail(item) {
        this.$router.push({ path: '/courseDetail', query: { courseId: item.courseId ,itemId: item.itemId}});
      },
      redrect2Course() {
        if (this.search == null || this.search == "") {
          return;
        }
        this.showResult = false;
        this.$router.push({ path: '/course', query: { search: this.search}});
      },
      async searchCourse() {
        if (this.search == null || this.search == "") {
          return;
        }
        this.courseList = [];
        let dataParam = {};
        dataParam.curPage = 1;
        dataParam.pageCount = 10;
        dataParam.search = this.search;
        let courseResult = await getCourseList(dataParam);
        if (courseResult && courseResult.rows) {
          this.courseList = courseResult.rows;
        }
        this.showResult = true;
      },
      async searchMobileCourse() {
        if (this.search == null || this.search == "") {
          return;
        }
        this.courseList = [];
        let dataParam = {};
        dataParam.curPage = 1;
        dataParam.pageCount = 10;
        dataParam.search = this.search;
        let courseResult = await getCourseList(dataParam);
        if (courseResult && courseResult.rows) {
          this.courseList = courseResult.rows;
        }
        this.showResult = true;
      },
      switchCourse(index) {
        this.panel = "course";
        this.selectCate = this.cateList[index];
        this.selectCate.index = index;
      },
      redrect2Item(index) {
        const routeUrl = this.$router.resolve({ path: '/programItem', query: { itemIndex: index}});
        window.open(routeUrl.href, "_blank");
      },
      switchProgram(index) {
        this.panel = "program";
        this.selectProgram = this.programs[index];
        this.selectProgram.index = index;
      },
      redrect2Url(path) {
        this.showMoblileMenu = false;
        this.$router.push('/' + path);
        // window.location.href = "/#/" + path;
        this.homeActive = "";
        this.courseActive = "";
        this.programActive = "";
        if (path == "home") {
          this.homeActive = "active";
        } else if (path == "course") {
          this.courseActive = "active";
        } else if (path == "program") {
          this.programActive = "active";
        }
      }
    },
  }
</script>

<style>
  .moble-search {
    width: 100% !important;
    border: solid 1px #03d068;
    line-height: 35px;
    border-radius: 8px;
    padding-left: 10px;
  }
  .hideHeader {
    padding: 0 0 0 0 !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/HeaderTop/HeaderTop.vue